import { useState, useEffect } from "react"

import { LoanApplicationState } from "@lib/clients/nelo-api-client"
import { neloApiClient } from "@lib/config-client"

export const useCheckSufficientFunds = (
  loanApplicationState: LoanApplicationState | null,
  cartTotal: number | null,
  hasOrderBeenPlaced: boolean
) => {
  const [isSufficientFunds, setIsSufficientFunds] = useState<boolean | null>(null)
  const [creditLimit, setCreditLimit] = useState<number | null>(null)

  useEffect(() => {
    if (!hasOrderBeenPlaced || loanApplicationState !== LoanApplicationState.APPROVED || cartTotal === null) return

    const checkStatus = async () => {
      try {
        // fixme: don't do another request here, just use what we already have in the loanApplicationState response
        const response = await neloApiClient.checkLoanApplicationStatus()
        const approvedCreditLimit = response.maxCreditLimit
        setCreditLimit(approvedCreditLimit)
        const sufficientFunds = cartTotal <= approvedCreditLimit
        setIsSufficientFunds(sufficientFunds)
      } catch (error) {
        console.error("Error checking sufficient funds:", error)
      }
    }

    checkStatus()
  }, [hasOrderBeenPlaced, loanApplicationState, cartTotal])

  return { isSufficientFunds, creditLimit }
}
